import { Menu, MenuItem } from "@mui/material";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import { FilterAndSortButton, sortMenuStyles } from "../../components/TracksPageComponents/styles";
import { useState } from "react";
import { THEME } from "../../theme";
import NotificationsIcon from "@mui/icons-material/Notifications";

export interface ProjectsSortMenuProps {
  setProjects: (projects: any[]) => void;
  setPage: (page: number) => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
}

export const ProjectsSortMenu: React.FC<ProjectsSortMenuProps> = ({
  setProjects,
  setPage,
  sortBy,
  setSortBy,
}) => {
  const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
  const openSortMenu = Boolean(sortAnchorEl);

  const handleOpenSortDropdown = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setSortAnchorEl(event.currentTarget);
  };

  const handleSortDropdownClose = () => {
    setSortAnchorEl(null);
  };

  const handleSortChange = (newSortBy: string) => {
    if (sortBy === newSortBy) {
      handleSortDropdownClose();
      return;
    }
    setSortBy(newSortBy);
    setPage(0);
    setProjects([]);
    handleSortDropdownClose();
  };

  return (
    <>
      <FilterAndSortButton
        aria-controls={openSortMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openSortMenu ? "true" : undefined}
        onClick={handleOpenSortDropdown}
        sx={sortMenuStyles.button}
      >
        <SwapVertOutlinedIcon sx={{ margin: "5px" }} />
        Sort
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={sortAnchorEl}
        open={openSortMenu}
        onClose={handleSortDropdownClose}
        PaperProps={{
          style: sortMenuStyles.paperProps,
        }}
        sx={sortMenuStyles.menu}
      >
        <MenuItem
          sx={{ marginTop: 0 }}
          onClick={() => handleSortChange("Title")}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/music-equalizer--music-audio-note-wave-sound-equalizer-entertainment.svg"
            alt=""
          />
          Title
        </MenuItem>
        <MenuItem
          onClick={() => handleSortChange("Last modified")}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/clock.svg"
            alt=""
          />
          Last modified
        </MenuItem>
        <MenuItem
          onClick={() => handleSortChange("Notifications")}
        >
          <NotificationsIcon sx={{ fontSize: "25px", marginRight: "8px" }} />
          Notifications
        </MenuItem>
      </Menu>
    </>
  );
};
